import { performDraw, startSessionManagement } from '@datadog/browser-core';
export var LOGGER_COOKIE_NAME = '_dd_l';
export var LoggerSessionType;
(function (LoggerSessionType) {
    LoggerSessionType["NOT_TRACKED"] = "0";
    LoggerSessionType["TRACKED"] = "1";
})(LoggerSessionType || (LoggerSessionType = {}));
export function startLoggerSession(configuration, areCookieAuthorized) {
    if (!areCookieAuthorized) {
        var isTracked_1 = computeSessionType(configuration) === LoggerSessionType.TRACKED;
        return {
            getId: function () { return undefined; },
            isTracked: function () { return isTracked_1; },
        };
    }
    var session = startSessionManagement(LOGGER_COOKIE_NAME, function (rawType) { return computeSessionState(configuration, rawType); });
    return {
        getId: session.getId,
        isTracked: function () { return session.getType() === LoggerSessionType.TRACKED; },
    };
}
function computeSessionType(configuration) {
    if (!performDraw(configuration.sampleRate)) {
        return LoggerSessionType.NOT_TRACKED;
    }
    return LoggerSessionType.TRACKED;
}
function computeSessionState(configuration, rawSessionType) {
    var sessionType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeSessionType(configuration);
    return {
        isTracked: sessionType === LoggerSessionType.TRACKED,
        type: sessionType,
    };
}
function hasValidLoggerSession(type) {
    return type === LoggerSessionType.NOT_TRACKED || type === LoggerSessionType.TRACKED;
}
//# sourceMappingURL=loggerSession.js.map